import { useQuery } from '@tanstack/react-query';
import { getDivisions } from '../../api/organizations';
import { useProductSettings } from '@workspace/utils-react';
import type { Settings } from '../../AppContainer';

export const divisionsQueryKey = ['divisions'] as const;

export function useDivisions() {
  const { apiUrl } = useProductSettings<Settings>();
  return useQuery({
    queryKey: divisionsQueryKey,
    queryFn: () => getDivisions(apiUrl),
    staleTime: 5 * 60 * 1000,
  });
}
